<template>
  <main class="page news-page" v-if="$store.state.article">
    <div class="news-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'news'}">Новости</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>{{ $store.state.article.title }}</span>
        </li>
      </ul>
      <img :alt="$store.state.article.title" class="news-page__image"
           :src="$store.state.article.img350 | findSource($store.state.api)"/>
      <div class="news-page__article">
        <h1 class="news-page__title">{{ $store.state.article.title }}</h1>
        <div class="news-page__content" v-html="$store.state.article.content"></div>
      </div>
      <div class="row" style="margin: 20px 0" v-if="$store.state.article.img650 && $store.state.article.img650.length">
        <div class="col-5" v-for="(img, i) in $store.state.article.img650" :key="i">
          <a
            target="_blank"
            :href="img | findSource2($store.state.api)"
          >
            <img
              style="width: 100%; height: auto"
              :src="img | findSource2($store.state.api)"
              :alt="$store.state.article.title"
            />
          </a>
        </div>
      </div>
      <div class="news-page__share">
        <span class="news-page__share__title">Поделиться</span>
        <div class="news-page__share__buttons">
          <ShareNetwork :url="$store.state.path" description="Описание" media="/public/img/main.png" network="vk"
                        title="Заголовок">
            <ShareVK/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" network="odnoklassniki" title="Заголовок">
            <ShareOK/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" network="twitter" title="Заголовок">
            <ShareTW/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" description="Описание" network="whatsapp" title="Заголовок">
            <ShareWH/>
          </ShareNetwork>
          <ShareNetwork :url="$store.state.path" description="Описание" network="telegram" title="Заголовок">
            <ShareTM/>
          </ShareNetwork>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import ShareFB from 'components/svg/ShareFB.vue'
import ShareVK from 'components/svg/ShareVK.vue'
import ShareOK from 'components/svg/ShareOK.vue'
import ShareWH from 'components/svg/ShareWH.vue'
import ShareTM from 'components/svg/ShareTM.vue'
import ShareTW from 'components/svg/ShareTW.vue'

export default {
  components: {
    ShareTW,
    ShareTM,
    ShareWH,
    ShareOK,
    ShareVK,
    ShareFB
  },
  async asyncData({store, host, route}) {
    store.state.path = `https://${host}${route.path}`
    await store.dispatch('ARTICLE_PAGE', route.params.id)
  },
  name: 'ArticlePage',
  metaInfo() {
    return this.$store.state.article ? this.$seo(
      'common',
      this.$store.state.article.title,
      'управление образования, образование, администрация',
      this.$store.state.article.subtitle,
      this.$store.state.article.title,
      this.$options.filters.findSource(this.$store.state.article.img350, this.$store.state.api),
      this.$store.state.article.subtitle
    ) : this.$seo('common', '', '', '', '', '', '')
  }
}
</script>
